import { render, staticRenderFns } from "./AttributePopoverBase.vue?vue&type=template&id=7d395512"
import script from "./AttributePopoverBase.vue?vue&type=script&lang=js"
export * from "./AttributePopoverBase.vue?vue&type=script&lang=js"
import style0 from "./AttributePopoverBase.vue?vue&type=style&index=0&id=7d395512&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports